import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import SEPARefundsViewModel from "viewModels/finance/refundApprovals/transferRefunds/SEPARefunds/SEPARefundsViewModel";
import TransferRefundsView from "../transferRefundsView";

const SEPARefundsView: ViewComponent<SEPARefundsViewModel> = observer(({ vm }) => <TransferRefundsView key={vm.name} vm={vm} />);

registerView(SEPARefundsView, SEPARefundsViewModel);
